export const CHANGE_PAYWALL_STEPS = {
  PAYWALL: "paywall",
  PRICES: "prices",
  CONFIRMATION: "summary",
};
